import { AgeGroupInterface, CategoryType, milestoneError, MilestoneType } from './Interface';
export enum milestoneTypes {
	LOAD_CATEGORY = 'LOAD/CATEGORY',
	LOAD_MILESTONE_BY_CATEGORY = 'LOAD/MILESTONE/CATEGORY',
	LOAD_MILESTONE_DETAILS = 'LOAD/MILESTONE/DETAILS',
	LOAD_MILESTONE_QUESTIONS = 'LOAD_MILESTONE_QUESTIONS',
	LOAD_MILESTONE_FAIL = 'LOAD_MILESTONE_FAIL',
	LOAD_MILESTONE_ERROR = 'LOAD_MILESTONE_ERROR',
	SAVE_MILESTONE = 'SAVE/MILESTONE',
	LOAD_AGE_GROUP = 'LOAD/AGE/GROUP',
}

interface MilestoneCategories {
	type: typeof milestoneTypes.LOAD_CATEGORY;
	payload: {
		data: CategoryType[];
	};
}
interface MilestoneLoadByCategory {
	type: typeof milestoneTypes.LOAD_MILESTONE_BY_CATEGORY;
	payload: {
		data: MilestoneType[];
	};
}
interface MilestoneDetails {
	type: typeof milestoneTypes.LOAD_MILESTONE_DETAILS;
	payload: {
		data: MilestoneType;
	};
}
interface MilestoneAchieved {
	type: typeof milestoneTypes.SAVE_MILESTONE;
	// payload:{
	//     data:
	// }
}
interface LoadAgeGroupInterface {
	type: typeof milestoneTypes.LOAD_AGE_GROUP;
	payload: {
		data: AgeGroupInterface;
	};
}
interface Load_Milestone_Fail {
	type: typeof milestoneTypes.LOAD_MILESTONE_FAIL;
	payload: {
		errors: any | undefined;
	};
}

interface LOAD_MILESTONE_ERROR {
	type: typeof milestoneTypes.LOAD_MILESTONE_ERROR;
	payload: {
		message: milestoneError;
	};
}

export type MilestoneTypeAction =
	| MilestoneCategories
	| MilestoneLoadByCategory
	| MilestoneDetails
	| MilestoneAchieved
	| LoadAgeGroupInterface
	| LOAD_MILESTONE_ERROR
	| Load_Milestone_Fail;
